import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AuthService } from '../../_services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../../_services/data.service';
import { anim, slideUp } from 'src/app/animations';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
  animations: [
    slideUp, anim
  ]
})
export class UserProfileComponent {
  projUid: string;
  compId: string;
  compositeDesign: boolean = false;
  unika: boolean = false;
  showRoles: boolean = false;
  @Output() personSent = new EventEmitter<{ name: string; email: string }>();
  
  constructor(public auth: AuthService, public translate: TranslateService, public dataService: DataService, private route: ActivatedRoute, private router: Router,) {
    this.projUid = this.route.snapshot.params.idp;
    this.compId = this.route.snapshot.params.id;
    if (!this.route.snapshot.params.id && this.route.snapshot.routeConfig.path != 'user') {
      this.projUid = this.route.firstChild.snapshot.params.idp;
      this.compId = this.route.firstChild.snapshot.params.id;
    }
  }

  ngOnInit(){
    this.compositeDesign = this.dataService.wichDesign().compositeDesign;
    this.unika = this.dataService.wichDesign().unika;
    const person = { name: 'John Doe', email: 'john.doe@example.com' };
    this.personSent.emit(person);
    this.auth.currentUserSubject;
    this.auth.handleRedirect();
  }

  goToEditorView() {
    if (this.projUid) {
      if(this.compositeDesign){
        localStorage.setItem('theme', 'compositDesign');
        // this.router.navigate(['/editor/company/n/' + this.compId + '/' + this.projUid]);
      } else {
        localStorage.setItem('theme', JSON.stringify(''));
      }
      // window.location.href = '/editor/company/' + this.compId + '/' + this.projUid
      // this.router.navigate(['/editor/company/' + this.compId + '/' + this.projUid]);
      // window.location.href = 'https://spirical.net/company/' + this.compId + '/' + this.projUid
    } else {
      if(this.compositeDesign){
        localStorage.setItem('theme', 'compositDesign');
        // this.router.navigate(['/editor/n']);
      } else {
        localStorage.setItem('theme', JSON.stringify(''));
      }
      // this.router.navigate(['/editor']);
    }
  }
}
